/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Clipboard from 'services/clipboard';

interface TradingIdProps {
  description: string;
  tradingId: string | undefined;
}

const TradingId = (props: TradingIdProps) => {
  const { description, tradingId } = props;

  const [balloonText, setBalloonText] = useState<string>('Clique para copiar o número.');

  const copyToClipboard = () => {
    const element = document.querySelector('.tradingId');

    if (!element) return;

    if (Clipboard.copyElement(element)) setBalloonText('Número copiado com sucesso.');
  };

  return (
    <label
      onClick={() => copyToClipboard()}
      onMouseOut={() => setBalloonText('Clique para copiar o número.')}
      className="ml-2 badge badge-secondary mb-0 databalloon"
      aria-label={balloonText}
      data-balloon-pos="down"
      data-balloon-blunt
    >
      {description} <span className="tradingId">{tradingId}</span>
    </label>
  );
};

export default TradingId;
